import React from 'react';
import BaseLayout from '@/components/layouts/BaseLayout';
import ArticleCard from '@/components/Article/ArticleCard';
import { useArticles } from '@/hooks/useArticles';

const HomePage: React.FC = () => {
  const { articles, isLoading, error } = useArticles();

  // Debug log
  console.log('Articles loaded:', articles);

  if (isLoading) {
    return (
      <BaseLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="animate-pulse space-y-8">
            <div className="h-64 bg-gray-200 rounded-xl"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="h-80 bg-gray-200 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </BaseLayout>
    );
  }

  if (error) {
    return (
      <BaseLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Error Loading Articles</h1>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
      </BaseLayout>
    );
  }

  if (!isLoading && articles.length === 0) {
    return (
      <BaseLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">No articles found</h1>
          </div>
        </div>
      </BaseLayout>
    );
  }

  const featuredArticle = articles[0];
  const latestArticles = articles.slice(1);

  return (
    <BaseLayout>
      <div className="container mx-auto px-4 py-8">
        {/* Featured Article */}
        {featuredArticle && (
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Featured Article</h2>
            <ArticleCard article={featuredArticle} featured />
          </div>
        )}

        {/* Latest Articles */}
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Latest Articles</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default HomePage;